module.exports = __webpack_public_path__ + "img/rocket_sign.fb1196b7.png";